import React, {Component} from 'react';
import classnames from 'classnames';
import SlatePaneBar from './SlatePaneBar';
import SlateIframe from '../SlateIframe/SlateIframe';
import './styles.css';
import {updateSlatePane, slatePaneContentLoaded, slatePaneContentChanged, slatePaneContentSaved} from "../../store/actions/slatePane";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

class SlatePane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: [],
      disableTransition: false,
    };
    this._mediaQuery = null;
    this._handleBreakpoint = this._handleBreakpoint.bind(this);
  }

  componentDidMount() {
    this._mediaQuery = window.matchMedia('(min-width: 991px)');
    if (this._mediaQuery.addEventListener) {
      this._mediaQuery.addEventListener('change', this._handleBreakpoint);
    } else {
      this._mediaQuery.addListener(this._handleBreakpoint);
    }
  }

  componentWillUnmount() {
    if (this._mediaQuery) {
      if (this._mediaQuery.removeEventListener) {
        this._mediaQuery.removeEventListener('change', this._handleBreakpoint);
      } else {
        this._mediaQuery.removeListener(this._handleBreakpoint);
      }
    }
  }

  _handleBreakpoint() {
    var self = this;
    self.setState({ disableTransition: true });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        self.setState({ disableTransition: false });
      });
    });
  }

  componentDidUpdate(prevProps) {
    // Send reset to iframe only when pane is explicitly closed (content cleared),
    // not when merely hidden by navigating to a non-pane route
    if (prevProps.isOpen && !this.props.isOpen && !this.props.slateUUID && !this.props.contentJson) {
      var paneEl = this.paneRef;
      if (paneEl) {
        var iframe = paneEl.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ type: 'reset' }, '*');
        }
      }
    }
  }

  handleColorChange = (colors) => {
    this.setState({colors: colors});
  }

  handleNavigateRejected = (loadedSlateUUID) => {
    this.props.updateSlatePane({
      slateInSlatePaneUUID: loadedSlateUUID,
    });
  }

  render() {
    var props = this.props;

    return (
      <div
        ref={(el) => { this.paneRef = el; }}
        className={classnames({
          'slate-pane': true,
          'slate-pane-active': props.isOpen,
          'slate-pane-hidden': props.isHidden,
          'slate-pane-docked': props.isDocked,
          'slate-pane-no-transition': this.state.disableTransition,
        })}
        style={{
          backgroundColor: this.state.colors.length > 0 ? this.state.colors[this.state.colors.length - 1] : '#001b32c7',
          ...(props.style || {})
        }}
      >
        {props.isHidden && (
          <div className="slate-pane-inner-overlay" onClick={props.onShow}/>
        )}
        <SlatePaneBar
          onDock={props.onDock}
          onHide={props.onHide}
          onPrev={props.onPrev}
          onNext={props.onNext}
          slateUUID={props.slateUUID}
          isDocked={props.isDocked}
        />
        <SlateIframe
          slateUUID={props.slateUUID}
          imageUrl={props.imageUrl}
          contentJson={props.contentJson}
          contentMode={props.contentMode}
          slateType={props.slateType}
          forceRefresh={props.slatePaneForceRefresh}
          wrapClassName="slate-full-page-wrap"
          iframeClassName="slate-full-page"
          onColorChange={this.handleColorChange}
          onNavigateRejected={this.handleNavigateRejected}
          onContentLoaded={props.slatePaneContentLoaded}
          onContentChanged={props.slatePaneContentChanged}
          onContentSaved={props.slatePaneContentSaved}
        />
      </div>
    );
  }
}

var mapStateToProps = function (state) {
  return {
    slatePaneForceRefresh: state.slatePane.slatePaneForceRefresh,
  };
};

var mapDispatchToProps = {
  updateSlatePane: updateSlatePane,
  slatePaneContentLoaded: slatePaneContentLoaded,
  slatePaneContentChanged: slatePaneContentChanged,
  slatePaneContentSaved: slatePaneContentSaved,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SlatePane));
